import { render, staticRenderFns } from "./TodoInspectionDrawer.vue?vue&type=template&id=8c352ad4&scoped=true&"
import script from "./TodoInspectionDrawer.vue?vue&type=script&lang=js&"
export * from "./TodoInspectionDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c352ad4",
  null
  
)

export default component.exports